module.exports = __webpack_public_path__ + "img/play.ec4eabc2.svg";